export const GLOBAL_CLIENT_FETCH_TIMEOUT = 120000;
//# sourceMappingURL=index.js.map